// extracted by css-extract-rspack-plugin
export default {"container":"_c47efad2","textContainer":"_215c1f2f","text":"_c31649c8","readMore":"_3d58fd32"};